var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMobileChallengesSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.7 13C0.7 10.5673 1.42138 8.18921 2.77293 6.16648C4.12447 4.14376 6.04547 2.56724 8.293 1.63628C10.5405 0.705323 13.0137 0.461743 15.3996 0.936342C17.7856 1.41094 19.9772 2.58241 21.6974 4.30259C23.4176 6.02278 24.5891 8.21443 25.0637 10.6004C25.5383 12.9864 25.2947 15.4595 24.3637 17.707C23.4328 19.9545 21.8562 21.8755 19.8335 23.2271C17.8108 24.5786 15.4327 25.3 13 25.3",
    stroke: "black",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 19L13 15V6.5",
    stroke: "black",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMobileChallengesSelected);
export default __webpack_public_path__ + "static/media/icon-mobile-challenges-selected.88d258b63b87453d038872e2d43e0dc9.svg";
export { ForwardRef as ReactComponent };